import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-620dd2ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag-list" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, null, -1 /* HOISTED */))
const _hoisted_5 = { class: "manga-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_check_tag = _resolveComponent("el-check-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tagList, (tagItem) => {
          return (_openBlock(), _createBlock(_component_el_check_tag, {
            class: "check-tag",
            color: tagItem.tagColor,
            checked: tagItem.checked,
            key: tagItem.tagId,
            style: _normalizeStyle($setup.tagStyle(tagItem.checked, tagItem.tagColor)),
            onChange: (status) => { $setup.onChange(tagItem, status) },
            effect: "dark",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tagItem.tagName), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color", "checked", "style", "onChange"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(['manga-list-box', { block: $setup.config.viewType === 'list' }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mangaList, (mangaItem) => {
          return (_openBlock(), _createBlock($setup["manga"], {
            key: mangaItem.mangaId,
            viewType: $setup.config.viewType,
            mangaInfo: mangaItem,
            onContextmenu: _withModifiers(($event: any) => ($setup.context_menu(mangaItem)), ["prevent"])
          }, null, 8 /* PROPS */, ["viewType", "mangaInfo", "onContextmenu"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 2 /* CLASS */)
    ]),
    _createCommentVNode("分页组件"),
    _createVNode($setup["mediaPager"], {
      ref: "pager",
      page: $setup.page,
      count: $setup.count,
      "page-size-config": $setup.pageSizes,
      onPageChange: $setup.page_change
    }, null, 8 /* PROPS */, ["page", "count", "page-size-config"])
  ], 64 /* STABLE_FRAGMENT */))
}